/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetApprovalCompetencyResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'ApprovalCompetency',
        isRequired: true,
      },
    },
  }],
} as const;
